export const DEFAULT_CENTER = [39.8283, -98.5795]
export const DEFAULT_ZOOM = 4
const STORE_ZOOM = 11
const METRO_ZOOM = 10

export const isLatLng = point => Array.isArray(point) && point.length === 2 && point.every(Number.isFinite)

const centeredView = (center, focus) => {
  if (isLatLng(center)) return { center, zoom: STORE_ZOOM }
  if (isLatLng(focus)) return { center: focus, zoom: METRO_ZOOM }
  return { center: DEFAULT_CENTER, zoom: DEFAULT_ZOOM }
}

export function initialViewport({ points = [], center = null, focus = null }) {
  const view = centeredView(center, focus)
  return points?.length > 1 ? { ...view, bounds: points } : view
}
